import { graphql } from "babel-plugin-relay/macro";
import { useQuery } from "relay-hooks";
import { useTtsVoicesQuery } from "./__generated__/useTtsVoicesQuery.graphql";

const ttsVoicesQL = graphql`
  query useTtsVoicesQuery($lang: String!) {
    ttsVoices(lang: $lang) {
      voices {
        id
        name
        gender
        type
        platform
      }
      sampleTexts
    }
  }
`;

type UseTtsVoicesOptions = {
  lang?: string;
  skip?: boolean;
};

const useTtsVoices = ({ lang, skip = false }: UseTtsVoicesOptions = {}) => {
  const { data, isLoading } = useQuery<useTtsVoicesQuery>(ttsVoicesQL, { lang: lang || "" }, { skip });

  return {
    data,
    isLoading
  };
};

export default useTtsVoices;
